import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Divider,
  Avatar,
  Typography
} from '@mui/material';
import { shades } from '../../../theme';
import NotificationsIcon from '@mui/icons-material/Notifications';

const user = {
  first_name: 'John',
  last_name: 'Doe',
  username: 'johndoe123',
  email: 'johndoe@example.com',
  date_of_birth: '1990-05-15',
  gender: 'male',
  address: '123 Main St, Apt 4B',
  phone_number: '+254712345678',
  avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
  country: 'Kenya',
  city: 'Nairobi',
  postal_code: '00100',
  street: 'Main Street',
  country_code: '+254'
};

// Profile Section
const Profile = () => {
  return (
    <Box
      sx={{
			  width: 300,
			  p: 2,
			  marginTop: '10vh',
			  boxShadow: 'none',
			  backgroundColor: 'white',
			  display: { xs: 'none', sm: 'none', md: 'block' }
      }}
    >
      <Card
        sx={{
				  backgroundColor: 'white',
				  color: shades.white[100],
				  boxShadow: 'none',
				  border: '1px solid #ddd'
        }}
      >
        <CardContent>
          <Box display='flex' alignItems='center'>
            <Avatar
              sx={{
							  width: 56,
							  height: 56,
							  mr: 2,
							  backgroundColor: shades.primary[400]
              }}
              src={user.avatar}
            />
            <Box>
              <Typography
                variant='h6'
                color={shades.neutral[600]}
              >{`${user.first_name} ${user.last_name}`}
              </Typography>
              <Typography variant='body2' color={shades.neutral[400]}>
                {user.username}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
      {/* User Details Section */}
      <Box
        sx={{
				  marginTop: '1vh',
				  padding: 2,
				  backgroundColor: shades.white[100],
				  borderRadius: '8px',
				  border: '1px solid #ddd'
        }}
      >
        <Box sx={{ marginTop: '1vh', padding: 2, borderRadius: '8px' }}>
          <Typography variant='h6' color={shades.secondary[600]}>
            Friends
          </Typography>
          <Box display='flex' flexWrap='wrap'>
            <Avatar
              sx={{
							  width: 20,
							  height: 20,
							  marginRight: 1,
							  color: shades.white[100]
              }}
              src='friend-avatar.jpg'
            />
            <Avatar
              sx={{
							  width: 20,
							  height: 20,
							  marginRight: 1,
							  color: shades.white[100]
              }}
              src='friend-avatar.jpg'
            />
            <Avatar
              sx={{
							  width: 20,
							  height: 20,
							  marginRight: 1,
							  color: shades.white[100]
              }}
              src='friend-avatar.jpg'
            />
          </Box>
        </Box>
        <Box sx={{ marginTop: '1vh', padding: 2, borderRadius: '8px' }}>
          <Typography variant='h6' color={shades.secondary[600]}>
            My Groups
          </Typography>
          <Box display='flex' flexDirection='column'>
            <Typography variant='body2' color={shades.neutral[600]}>
              Group 1: Medi Chat
            </Typography>
            <Typography variant='body2' color={shades.neutral[600]}>
              Group 2: Health Tips
            </Typography>
          </Box>
        </Box>
        <Box sx={{ marginTop: '1vh', padding: 2, borderRadius: '8px' }}>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
            <Typography variant='h6' color={shades.secondary[800]}>
              Notifications
            </Typography>
            <NotificationsIcon sx={{ color: shades.secondary[800] }} />
          </Box>
          <Box
            display='flex'
            alignItems='center'
            justifyContent='space-between'
            sx={{ backgroundColor: '#28a745', padding: 1, borderRadius: '8px' }}
          >
            <Typography variant='body2' color={shades.white[100]}>
              New comment on your post
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Profile;
